import { TextField } from '@material-ui/core'

import { FORM_TEXT } from '../ExtensionModal'
import type { formErrors, formVals } from '../ExtensionModal'

type props = {
  formValues: formVals
  handleInputsChange: (name: string, value: string | Date | number) => void
  formErrors: formErrors
  isEditing: boolean
}
const Email = ({ formValues, formErrors, isEditing, handleInputsChange }: props) => {
  return (
    <TextField
      required
      id="extensionStudentEmail"
      variant="outlined"
      value={formValues.studentEmail ?? ''}
      error={!!formErrors.studentEmail}
      helperText={formErrors.studentEmail ?? ''}
      FormHelperTextProps={{ role: 'alert' }}
      label={FORM_TEXT.emailLabel}
      disabled={isEditing}
      name="studentEmail"
      autoComplete="email"
      onChange={(e) => handleInputsChange(e.target.name, e.target.value)}
    />
  )
}

export default Email
